import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import { getInnerHTMLFormat } from '../../../../../helpers/utils';
import Style from '../../../../../styles/common';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  padding: 1rem 0;
`;

const Text = styled('span')`
  display: block;
`;

const Title = styled(Text)`
  font-family: ${Style.FONT_FAMILY.DEFAULT};
  font-size: 1rem;
  font-weight: ${Style.FONT_WEIGHT.MEDIUM};
  letter-spacing: 0.5px;
  line-height: 1.4;
  margin: 1.5rem 0;
`;

const Icon = styled(FontAwesomeIcon)`
  color: ${Style.color.iconDefault};
  margin-right: 0.5rem;
  width: 0.75rem;
`;

const Detail = styled(Text)`
  color: ${Style.color.DETAIL_TEXT};
  font-size: 0.8125rem;
  margin: .5rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

function EventCardDetails(props) {
  return (
    <Container>
      <Title {...getInnerHTMLFormat(props.title)} />
      <div>
        <Detail>
          <Icon icon="calendar" />
          {props.dateTime}
        </Detail>
        {getLocation(props.location)}
      </div>
    </Container>
  );
}

function getLocation(location) {
  if (!location) {
    return null;
  }

  return <Detail><Icon icon="map-marker-alt" />{strip(location)}</Detail>;
}

function strip(html) {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}

EventCardDetails.propTypes = {
  dateTime: PropTypes.string,
  location: PropTypes.string,
  title: PropTypes.string.isRequired
};
EventCardDetails.defaultProps = {
  dateTime: '',
  location: '',
};

export default EventCardDetails;



// WEBPACK FOOTER //
// ./src/views/Browse/Events/EventCard/EventCardDetails/EventCardDetails.js